import o from"../token/TokenId.js";import r from"../ObjectMap.js";class t extends r{constructor(){super(r=>o.fromString(r))}}export{t as default};
//# sourceMappingURL=TokenBalanceMap.js.map
